import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import MarketingHeading from "../../common/MarketingHeading"

const ContactTheTeamCTA = () => {
  return (
    <Card className="rounded-2xl p-[50px] md:p-[100px] bg-bg-surface w-full px-12 py-16">
      <div className="flex flex-col gap-4 items-center justify-center">
        <div className="text-sm text-fg-secondary">Join the others</div>
        <MarketingHeading
          level={1}
          className="text-center"
          style={{
            fontSize: "50px",
            letterSpacing: "-3px",
            lineHeight: ".95em",

            fontWeight: 500,
          }}
        >
          Talk to our team
        </MarketingHeading>
        <LinkButton size="large" href="/contact" className="mt-2">
          Contact us
        </LinkButton>
      </div>
    </Card>
  )
}

export default ContactTheTeamCTA
